import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "14",
  viewBox: "0 0 18 14",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#fff\"><path d=\"m0 4h4v6h-4z\"></path><path d=\"m3 4 5-4v14l-5-4z\"></path><path d=\"m11.4146 3.46436 5.6568 5.65685-1.4142 1.41419-5.6569-5.65683z\"></path><path d=\"m17.0713 4.87891-5.6569 5.65689-1.4142-1.41425 5.6569-5.65686z\"></path></g>", 1)
  ]))]))
}
export default { render: render }